import { Button, message, Modal, Upload } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { uploadImg } from '../../api/api'
import { getBase64 } from '../../utils/getbase64'
import handleFileInUploading from '../../utils/cos'

const UploadMultiplePicture = (props) => {
  // console.log(props.images);
  const images = props.images.map((item, index) => {
    return {
      uid: index,
      name: `image${index}`,
      status: 'done',
      url: item,
    }
  })
  const [fileList, setFileList] = useState(images)
  const [thumbUrl, setThumbUrl] = useState()
  //向父组件传值
  const deliverUrl = props.deliverUrl

  //图片预览
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')
  const [isRemove, setIsRemove] = useState(false)
  const myUpload = (file) => {
    //转化为formData格式
    // console.log(file)
    // let formData = new FormData()
    // formData.append('file', file.file)
    // // console.log(formData)

    // uploadImg(formData).then((res) => {
    //   // console.log(res.data.data.thumbnail)
    //   setThumbUrl(res.data.data.thumbnail)
    //   setIsRemove(false)
    //   deliverUrl(res.data.data.thumbnail)
    // })

    const afterUpload = (url) => {
      setIsRemove(false)
      const image =
        'https://' + url.replace('cos.accelerate', 'cos-website.ap-shanghai')

      const newList = [...fileList]
      // console.log(fileList,newList);
      newList.push({
        uid: newList.length + 1,
        url: image,
        name: `内容图片${newList.length + 1}`,
        status: 'done',
      })
      setFileList(newList)

      deliverUrl(image)
      if ((url ?? false) && url !== '') {
        message.success('图片上传成功！')
      }
      // console.log(url);
    }
    handleFileInUploading(file.file, afterUpload)
  }

  const handleChange = ({ file, fileList }) => {
    // console.log('handleCHange', file)
    // console.log('thumbUrl', thumbUrl)
    // if (file.status === 'uploading') {
    //   setFileList((pre) => {
    //     // console.log("pre",pre);
    //     return [
    //       ...pre,
    //       {
    //         ...file,
    //         url: thumbUrl,
    //         status: 'done',
    //       },
    //     ]
    //   })
    // }

    if (file.status === 'removed') {
      const removeId = file.uid
      const newList = fileList.filter((item) => item.uid !== removeId)
      setFileList(newList)
      deliverUrl(newList)
    }
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('只能上传JPG或PNG文件!')
      return false
    }
    const isLt100M = file.size / 1024 / 1024 < 100
    if (!isLt100M) {
      message.error('图片大小需小于100MB!')
      return false
    }

    return isJpgOrPng && isLt100M
  }

  // 方法：图片预览
  const handlePreview = async (file) => {
    if ((!file.url && !file.preview) ?? true) {
      file.preview = await getBase64(file.originFileObj)
    }
    // console.log('smyhvae handlePreview:' + JSON.stringify(file))
    setPreviewImage(file.url || file.preview)
    setPreviewOpen(true)
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    )
  }
  const handleCancel = () => setPreviewOpen(false)
  return (
    // <Upload name="logo" customRequest={myUpload} listType="picture">
    //   <Button icon={<UploadOutlined />}>上传图片</Button>
    // </Upload>
    <>
      <Upload
        multiple
        beforeUpload={beforeUpload}
        onChange={handleChange}
        customRequest={myUpload}
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        // onRemove={handleRemove}
      >
        {fileList.length >= props.count ? null : (
          <div>
            <PlusOutlined />
            <div
              style={{
                marginTop: 8,
              }}
            >
              上传图片
            </div>
          </div>
        )}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: '100%',
          }}
          src={previewImage}
        />
      </Modal>
    </>
  )
}

export default UploadMultiplePicture
